// extracted by mini-css-extract-plugin
export default {"content":"column_content__376Hv","column":"column_column__c68Af","default":"column_default__rHds9","changing":"column_changing__9NKJF","modified":"column_modified__C2-kz"};